import React from 'react';
import './index.scss';

interface IProps {
    /**
     * 显示文案，默认：暂无数据
     */
    tips?: string;
}

const Empty = (props: IProps) => {
    const { tips } = props;
    return (
        <div className="empty-wrapper">
            <img src={require('@/assets/images/roo1.png')} className="empty-wrapper__img" alt="" />
            <p className="empty-wrapper__tips">{tips}</p>
        </div>
    );
};

Empty.defaultProps = {
    tips: '暂无数据',
};

export default Empty;
